export default {
	PlaceholderSearch: 'Enter title, sender to search',
	DateReceived: 'Receiving date',
	FromDate: 'From',
	ToDate: 'To',
	UnProgress: 'Unprocessed',
	Progress: 'Processing',
	ProgressException: 'Error handling',
	EmailIllegal: 'The email is not valid',
	InvoiceDuplicated: 'Duplicate invoice',
	Progressed: 'Processed',
	ViewInvoice: 'View invoice',
	FileFound: 'Does not contain invoices',
	CheckAgain: 'Recheck',
	Delete: 'Delete',
	Restore: 'Restore',
	FileProcessed: {
		All: 'All',
		Valid: 'Valid',
		Invalid: 'Invalid',
		Duplicate: 'Duplicate invoice',
		Draft: 'Draft invoice',
		NoRead: 'Unprocessed invoice',
		Expired: 'Expired',
		OutOfQuantity: 'Out of usage invoices',
		FileName: 'File name',
		Status: 'Status'
	},
	MailBox: 'Inbox',
	ImportantBox: 'Important mail',
	Refresh: 'Refresh',
	Filter: 'Filter',
	FilterMail: 'Filter',
	DeleteMailbox: 'Delete permanently',
	StatusEmail: 'Status',
	YetSelectEmail: 'No mail selected',
	ReadEmailStatus: 'Mail reading status',
	NoHasPdf: 'There is no PDF demonstration',
	UnRead: 'Mark as unread',
	AttachmentFile: 'Attachments',
	ListInvoice: 'Invoice list',
	InboxTab: {
		MailBox: 'Inbox',
		MailImportaint: 'Important mail',
		MailSpam: 'Spam mail',
		MailTrash: 'Trash mail'
	},
	WarningNoteSendXML: 'Please submit the XML invoice file to ensure the invoice check is done correctly',
	InboxSelectedWarning: number => `You can only select up to ${number} emails.`,
	Forward: {
		TitlePage: 'Forward mail',
		UserTake: 'Consignee',
		MailUserTake: 'Recipient email',
		LabelText: 'Title',
		LabelMail: 'E-mail header',
		AttachmentFile: 'Attachments',
		ResponseInvoiceText: 'feedback on your e-invoice',
		TakedEmailTex: 'has received the invoice below',
		SellerName: '&lt;Seller information&gt;',
		BuyerNameHtml: '&lt;Buyer information&gt;',
		BuyerName: '<Buyer information>',
		Translate: 'Translate'
	},
	InboxV2: {
		NoEmail: 'No mail yet',
		NoEmailDescription: 'Send invoices to the unit\'s invoice receiving email',
		TextPromptUserSendMail: 'You can send electronic invoices or forward (forward) your email electronic invoices',
		ToEmail: 'To Email',
		PromptHaveSomeEmail: 'You have {num} new emails',
		PromptSelectSomeEmail: 'selected',
		Deselect: 'Deselect',
		StatusReadMail: {
			Text: 'Mail reading status'
		},
		InvoicesStatus: {
			Text: 'Status',
			SelectAll: 'Select all',
			Valid: 'Valid',
			Invalid: 'Invalid invoice',
			Match: 'Duplicate invoice',
			CannotRead: 'Unprocessed invoice'
		},
		PromptCanNotReadEmail:
			'Currently, the system has not recognized invoice from this email. Please upload XML invoice to check directly',
		ConfirmDeleteEmail: "Data after deletion can still be restored in the 'Trash' section.",
		ConfirmDeleteAllEmailChoose: "Data after deletion can still be restored in the 'Trash' section.",
		ConfirmDeleteEmailTitle: 'Do you want to delete this mail?',
		InvoiceMatch: 'Duplicate invoice',
		EmailTakeInvoice: 'Invoice receiving email',
		EmailSizeExceeded: 'Email size exceeds 10MB',
		StorageInfo: {
			EmailStorage: {
				part1: 'Email storage: Maximum',
				part2: '6 months',
				part3: '; Invoice storage: Maximum',
				part4: '10 years'
			},
			MaxEmailSize: {
				part1: 'Maximum email size:',
				part2: '10MB'
			},
			SupportedAttachments: {
				part1: 'Supported attachments:',
				part2: 'PDF, XML, INV, images'
			},
			DeleteNote: 'Deleting emails does not affect invoices already stored in the program'
		},
		Max10MbWarning: sizeMB =>
			`Unable to process because your email size is <span style="color: #f5222d; font-weight: bold">${sizeMB}</span> MB. The software only accepts emails with a total size under <span style="color: #f5222d; font-weight: bold">10MB.</span> Please split into <strong>multiple emails</strong> and resend.`
	},
	SpamBox: {
		DontHaveEmail: 'No spam mail'
	},
	TrashBox: {
		DontHaveEmail: 'Trash is empty'
	},
	DeleteEmailSuccess: 'Deleted mail successfully',
	ReportSpamSuccess: 'Report spam successfully',
	ReportNotSpamSuccess: 'Report not spam successfully',
	ConfirmDeleteForeverEmail: 'Data after deletion cannot be restored.',
	ConfirmDeleteForeverAllChooseEmail: 'Data after deletion cannot be restored.',
	DeleteSpamEmailTite: 'Do you want to delete spam mail?',
	Draf: 'Draft',
	CheckingInvoice: 'Checking invoices',
	AlertSaveMail: 'All mails will be archived within 6 months from the date of receipt',
	WarningTextEmailSpoofed:
		'This email may be spoofed. Please read carefully before proceeding to avoid the risk of fraud!',
	WarningContentEmail: 'Email content cannot be empty.',
	SenderInformation: 'Sender information',
	From: 'From'
};
